import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7fdc4494"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "vod-search"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "info-warp"
};
const _hoisted_4 = {
  class: "left-warp"
};
const _hoisted_5 = {
  class: "search-input"
};
const _hoisted_6 = {
  class: "keyboard-warp"
};
const _hoisted_7 = {
  class: "top-board"
};
const _hoisted_8 = ["tabindex", "onClick"];
const _hoisted_9 = {
  class: "bottom-board"
};
const _hoisted_10 = ["tabindex", "onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["tabindex", "onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "right-warp"
};
const _hoisted_15 = {
  class: "search-tabs"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "result-list"
};
const _hoisted_18 = {
  class: "page-span"
};
import { getVodPlusSearchUrlApi } from '@/api/vodPlus';
import { debounce } from '@/utils/tools';
import { Search } from '@element-plus/icons-vue';
import { inject } from 'vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'vodSearchInfo',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'onSearchItemClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const topBoardList = ref([{
      name: '123',
      fn: () => {
        isNum.value = true;
      }
    }, {
      name: 'A/a',
      fn: () => {
        isUcOrLc.value = isUcOrLc.value == 'uc' ? 'lc' : 'uc';
      }
    }, {
      name: 'English',
      fn: () => {
        isNum.value = false;
      }
    }, {
      name: 'Delete',
      fn: () => {
        dataConfig.searchParams.searchValue = dataConfig.searchParams.searchValue.slice(0, dataConfig.searchParams.searchValue.length - 1);
      }
    }]);
    const currentSelectSearchTab = ref('movie');
    const resultTabs = ref([{
      label: 'Movies',
      value: 'movie'
    }, {
      label: 'Series',
      value: 'series'
    }, {
      label: 'Actor/Director',
      value: 'cast'
    }]);

    const changeSearchTabs = value => {
      dataConfig.paginationConfig.page = 0;
      currentSelectSearchTab.value = value;
      returnAllPageFunc();
    };

    const fromCharCode = () => {
      const dataArr = [];

      for (var i = 0; i < 26; i++) {
        dataArr.push({
          uc: String.fromCharCode(65 + i),
          lc: String.fromCharCode(65 + i).toLowerCase()
        });
      } // console.log('dataArr', dataArr);


      dataArr.push({
        uc: 'space',
        lc: 'space'
      });
      return dataArr;
    };

    const charCodeData = ref(fromCharCode());
    const numberBoardList = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 'space', 0, '.']);
    const dataConfig = reactive({
      searchParams: {
        searchValue: ''
      },
      data: [],
      paginationConfig: {
        page: 0,
        limit: 8,
        total: 0
      },
      isLoading: false
    });
    const actionForm = reactive({
      dialogConfig: {
        title: '搜索',
        // destroyOnClose: true,
        isShowFooter: false
      },
      close: () => {
        emit('update:modelValue', false);
      }
    });
    const allSearchData = ref([]);

    const getData = async () => {
      dataConfig.isLoading = true;
      dataConfig.data = [];

      try {
        let params = {
          cid: pageParams.categoryId,
          start: 0,
          total: 20,
          search: dataConfig.searchParams.searchValue
        };
        const res = await getVodPlusSearchUrlApi(params);
        console.log(res);

        if (res.status == 200) {
          // dataConfig.data = res.data.list.map(v => {
          //     if (v.type == 'cast') {
          //         v.nameId = v.id
          //     }
          //     return v
          // })
          // dataConfig.paginationConfig.total = res.data.totalNum
          // dataConfig.isLoading = false
          allSearchData.value = res.data.list.map(v => {
            if (v.type == 'cast') {
              v.nameId = v.id;
            }

            return v;
          });
          returnAllPageFunc();
        } else {
          dataConfig.isLoading = false;
        }
      } catch (error) {
        if (error.message !== 'canceled') {
          dataConfig.isLoading = false;
        }
      } // returnAllPageFunc()

    };

    const returnAllPageFunc = async () => {
      dataConfig.isLoading = true;
      dataConfig.data = [];
      setTimeout(() => {
        try {
          let filterData = allSearchData.value.filter(item => item.type == currentSelectSearchTab.value);
          let newArr = JSON.parse(JSON.stringify(filterData));
          dataConfig.data = newArr.splice(dataConfig.paginationConfig.page * dataConfig.paginationConfig.limit, dataConfig.paginationConfig.limit);
          dataConfig.paginationConfig.total = filterData.length;
        } catch (error) {}

        dataConfig.isLoading = false;
      }, 300);
    };

    const onSearch = debounce(() => {
      dataConfig.paginationConfig.page = 0;
      getData();
    }, 200);
    const isNum = ref(false);
    const isUcOrLc = ref('lc');

    const onLetterItemClick = item => {
      console.log(item[isUcOrLc.value]);
      dataConfig.searchParams.searchValue += item[isUcOrLc.value] == 'space' ? ' ' : item[isUcOrLc.value];
    };

    const onNumItemClick = item => {
      // dataConfig.searchParams.searchValue += item
      dataConfig.searchParams.searchValue += item == 'space' ? ' ' : item;
    };

    const handlePaginationChange = val => {
      dataConfig.paginationConfig.page = val - 1;
      returnAllPageFunc();
    }; // 搜索列表item点击事件


    const rightListItemClick = item => {
      //   console.log(item);
      emit('onSearchItemClick', item);
    };

    const pageParams = inject('pageParams');
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_m_dialog, {
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        "dialog-config": actionForm.dialogConfig,
        onOnClose: actionForm.close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
          modelValue: dataConfig.searchParams.searchValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dataConfig.searchParams.searchValue = $event),
          placeholder: _ctx.$t('请输入关键字'),
          onKeyup: _withKeys(_unref(onSearch), ["enter", "native"])
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: _unref(onSearch)
          }, null, 8, ["icon", "onClick"])]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onKeyup"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topBoardList.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "key-item",
            key: index,
            tabindex: index,
            onClick: item.fn
          }, _toDisplayString(item.name), 9, _hoisted_8);
        }), 128))]), _createElementVNode("div", _hoisted_9, [!isNum.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(charCodeData.value, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item[isUcOrLc.value] != 'space' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "key-item",
            tabindex: index,
            onClick: $event => onLetterItemClick(item)
          }, _toDisplayString(item[isUcOrLc.value]), 9, _hoisted_10)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "key-item iconfont icon-kongge",
            onClick: $event => onLetterItemClick(item)
          }, null, 8, _hoisted_11))], 64);
        }), 128)) : _createCommentVNode("", true), isNum.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(numberBoardList.value, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item != 'space' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "key-item num-key",
            tabindex: index,
            onClick: $event => onNumItemClick(item)
          }, _toDisplayString(item), 9, _hoisted_12)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "key-item num-key iconfont icon-kongge",
            onClick: $event => onNumItemClick(item)
          }, null, 8, _hoisted_13))], 64);
        }), 128)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultTabs.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["tabs-item pointer", item.value == currentSelectSearchTab.value ? 'is-search-tab-select' : '']),
            key: index,
            onClick: $event => changeSearchTabs(item.value)
          }, _toDisplayString(item.label), 11, _hoisted_16);
        }), 128))]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [dataConfig.data.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(dataConfig.data, (item, index) => {
          return _openBlock(), _createBlock(MoviesOrActorItem, {
            poster: item.image,
            "program-name": item.name,
            onClick: $event => rightListItemClick(item)
          }, null, 8, ["poster", "program-name", "onClick"]);
        }), 256)) : _createCommentVNode("", true), dataConfig.data.length == 0 && !dataConfig.isLoading ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          style: {
            "width": "100%"
          },
          "image-size": 50
        })) : _createCommentVNode("", true)])), [[_directive_loading, dataConfig.isLoading]])])]), _createElementVNode("div", {
          class: "pagination",
          style: _normalizeStyle(dataConfig.paginationConfig.total > dataConfig.paginationConfig.limit && !dataConfig.isLoading ? '' : 'visibility: hidden')
        }, [_createVNode(_component_el_pagination, {
          small: "",
          background: "",
          layout: "slot, prev, pager, next",
          "current-page": dataConfig.paginationConfig.page + 1,
          "page-size": dataConfig.paginationConfig.limit,
          total: dataConfig.paginationConfig.total,
          onCurrentChange: handlePaginationChange
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_18, _toDisplayString(dataConfig.paginationConfig.page * dataConfig.paginationConfig.limit + 1 + '-' + (dataConfig.paginationConfig.total / (dataConfig.paginationConfig.page + 1) > dataConfig.paginationConfig.limit ? (dataConfig.paginationConfig.page + 1) * dataConfig.paginationConfig.limit : dataConfig.paginationConfig.total)) + " of " + _toDisplayString(dataConfig.paginationConfig.total) + " items ", 1)]),
          _: 1
        }, 8, ["current-page", "page-size", "total"])], 4)])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnClose"])])) : _createCommentVNode("", true);
    };
  }

});